import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown, faCheck } from "@fortawesome/free-solid-svg-icons";

import '../styles/Dropdown.css';
import '../styles/Button.css';

export default class DropdownSimple extends React.Component
{
    constructor(props)
    {
        super(props)
        this.state = {
            isListOpen: false,
            headerTitle: this.props.title,
            sIconSelected: null
        }
    }

    toggleList = () =>
    {
        this.setState(prevState => ({
            isListOpen: !prevState.isListOpen,
        }));
    }

    selectItem = (aItem) =>
    {
        this.setState(
            {
                isListOpen: false
            },
            () => this.props.resetThenSet(aItem)
        );
        const customEvent = new CustomEvent('selectRepo');
          document.dispatchEvent(customEvent);

    }

    render()
    {
        const aItemsList = this.props.itemsList;
        const bIsTransparent = this.props.transparent;
        const bIsLTCorner = this.props.LTCorner;

        const aSelected = aItemsList.find(aItem =>
        {
            return aItem.selected ? true : false;
        });

        return (
            <div className={"Dropdown Dropdown--marginVertSmall"}>

                <button
                    type="button"
                    onClick={this.toggleList}
                    className={"Dropdown__button Dropdown__button--top" + (bIsTransparent ? " Dropdown__button--transparent" : "")}
                >
                    <div>
                        {(aSelected ? aSelected.label : this.state.headerTitle) + ' '}
                        {this.state.isListOpen
                            ? <FontAwesomeIcon icon={faAngleUp} />
                            : <FontAwesomeIcon icon={faAngleDown} />}
                    </div>
                </button>

                {this.state.isListOpen && (
                    <div className="Dropdown__list">
                        <div>
                            {aItemsList.map((item,key) =>
                            {
                                return (<div key={key}>
                                    <button
                                        key={"btn_"+key}
                                        type="button"
                                        onClick={() => this.selectItem(item)}
                                        className={"Dropdown__button".concat(item.selected ? " Dropdown__button--selected" : "")}
                                    >
                                        {item.label}
                                    </button>
                                </div>)
                            })
                            }
                        </div>
                    </div>
                )}

            </div>
        )
    }
}